import _ from "lodash";
import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";
const docModelo = {
  id: 0,
  id_proprietario: 0,
  id_tipo_documento: 0,
  registro: "",
  data_validade: "",
  nome_original: "",
};
export default {
  namespaced: true,
  state: {
    tiposPermitidos: [],
    docAtivo: null,
    tipos: [],
    proprietarios: [],
    tiposProprietario: [],
    modelo: _.clone(docModelo),
  },
  mutations: {
    carregarTiposPermitidos(state, tipos) {
      state.tiposPermitidos = tipos;
    },
    novo(state) {
      state.docAtivo = _.clone(docModelo);
    },
    editar(state, doc) {
      state.docAtivo = _.clone(doc);
    },
    limparAtivo(state) {
      state.docAtivo = null;
    },
    carregarTipos(state, tipos) {
      state.tipos = tipos;
    },
    carregarProprietarios(state, proprietarios) {
      state.proprietarios = proprietarios;
    },
    carregarTiposProprietario(state, tipos) {
      state.tiposProprietario = tipos;
    },
  },
  actions: {
    async listar(context, { urlBase, IDProprietario }) {
      try {
        const response = await securedAxios.get(
          `/${urlBase}/${IDProprietario}/documentos`
        );
        return Promise.resolve(response.data);
      } catch (e) {
        Promise.reject(e);
      }
    },
    download(context, { urlBase, doc }) {
      return securedAxios.get(
        `/${urlBase}/${doc.id_proprietario}/documentos/${doc.id}/download`,
        {
          responseType: "blob",
        }
      );
    },
    async gravar(context, { urlBase, IDProprietario, documentos }) {
      const promises = documentos.map((doc) => {
        return new Promise((resolve, reject) => {
          let p;
          if (doc.editar) {
            p = securedAxios.put(
              `/${urlBase}/${IDProprietario}/documentos/${doc.id}`,
              doc
            );
          } else if (doc.remover) {
            p = securedAxios.delete(
              `/${urlBase}/${IDProprietario}/documentos/${doc.id}`,
              doc
            );
          } else if (doc.novo) {
            const formData = new FormData();
            doc.id_proprietario = IDProprietario;
            Object.keys(doc).forEach((key) => formData.append(key, doc[key]));
            p = securedAxios.post(
              `/${urlBase}/${IDProprietario}/documentos/${doc.tipo_documento.id}`,
              formData
            );
          } else {
            return resolve(doc);
          }

          p.then(
            (response) => resolve(response.data),
            (err) => reject(err)
          );
        });
      });
      return Promise.all(promises);
    },
    async listarTiposPermitidos({ commit }, urlBase) {
      try {
        const response = await securedAxios.get(
          `${urlBase}/documentos-permitidos`
        );
        commit("carregarTiposPermitidos", response.data);
        return Promise.resolve(response.data);
      } catch (e) {
        commit("carregarTiposPermitidos", []);
        return Promise.reject(e);
      }
    },
    async carregarTipo(context, id) {
      try {
        const response = await securedAxios.get(`documentos/tipos/${id}`);
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async listarTipos({ commit }) {
      try {
        const response = await securedAxios.get("documentos/tipos");
        commit("carregarTipos", response.data);
      } catch (e) {
        commit("carregarTipos", []);
        return Promise.reject(e);
      }
    },
    async listarTiposProprietario({ commit }) {
      try {
        const response = await securedAxios.get("documentos/proprietarios");
        commit("carregarTiposProprietario", response.data);
        return Promise.resolve(response.data);
      } catch (e) {
        commit("carregarTiposProprietario", []);
        return Promise.reject(e);
      }
    },
    async gravarTipo(context, tipo) {
      try {
        let response;
        if (tipo.id === "") {
          delete tipo.id;
          response = await securedAxios.post("/documentos/tipos", tipo);
        } else {
          response = await securedAxios.put(
            `/documentos/tipos/${tipo.id}`,
            tipo
          );
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarProprietario(context, id) {
      try {
        const response = await securedAxios.get(
          `documentos/tipos-proprietario-doc/${id}`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async listarProprietarios({ commit }) {
      try {
        const response = await securedAxios.get(
          "documentos/tipos-proprietario-doc"
        );
        commit("carregarProprietarios", response.data);
      } catch (e) {
        commit("carregarProprietarios", []);
        return Promise.reject(e);
      }
    },
    async gravarProprietario(context, proprietario) {
      try {
        const response = await securedAxios.put(
          `/documentos/tipos-proprietario-doc/${proprietario.id}`,
          proprietario
        );

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async listarPacotes(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/documentos/pacotes?opcoes=${urljson(opcoes)}`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarPacote(context, id) {
      try {
        const response = await securedAxios.get(`/documentos/pacotes/${id}`);
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async gravarPacote(context, pacote) {
      try {
        let response;
        if (pacote.id == "") {
          delete pacote.id;
          response = await securedAxios.post("/documentos/pacotes", pacote);
        } else {
          var id = pacote.id;
          delete pacote.id;
          delete pacote.cliente;
          response = await securedAxios.put(
            "/documentos/pacotes/" + id,
            pacote
          );
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async documentosPacote(context, id_pacote) {
      try {
        const response = await securedAxios.get(
          `/documentos/pacotes/${id_pacote}/documentos`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async adicionarDocumentosPacote(context, { id_pacote, selecao }) {
      try {
        await securedAxios.post(
          `/documentos/pacotes/${id_pacote}/documentos/${selecao.tipo_proprietario.id}/${selecao.id_proprietario}`,
          {
            id_documentos: selecao.documentos_selecionados,
          }
        );
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async removerProprietarioPacote(
      context,
      { id_pacote, id_tipo_proprietario, id_proprietario }
    ) {
      try {
        await securedAxios.delete(
          `/documentos/pacotes/${id_pacote}/documentos/${id_tipo_proprietario}/${id_proprietario}`
        );
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    },
    downloadPacote(context, id_pacote) {
      return securedAxios.get(`/documentos/pacotes/${id_pacote}/download`, {
        responseType: "blob",
      });
    },
    removerPacote(context, id_pacote) {
      return securedAxios.delete(`/documentos/pacotes/${id_pacote}`);
    },
    async logEnvioPacote(context, id_pacote) {
      try {
        const response = await securedAxios.get(
          `/documentos/pacotes/${id_pacote}/envios`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async tamanhoPacote(context, id_pacote) {
      try {
        const response = await securedAxios.get(
          `/documentos/pacotes/${id_pacote}/tamanho`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async relatorioVencimento(context, filtros) {
      try {
        const response = await securedAxios.get(
          `/documentos/relatorio-vencimento?filtros=${urljson(filtros)}`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
